export default {
  FIXED: 'F',
  BASE: 'B'
}
